export const customerLookupMessages = {
  customer: 'Khách hàng',
  processing: 'Đang xử lý',
  contactHistory: 'Lịch sử liên hệ',
  customerName: 'Tên khách hàng',
  customerAddress: 'Địa chỉ',
  district: 'Quận/Huyện',
  ward: 'Phường/Xã',
  customerPhone: 'Số điện thoại',
  requestCode: 'Mã yêu cầu',
  other: 'Khác',
  customerCode: 'Mã khách hàng',
  newRegister: 'Đăng ký mới',
  lookup: 'Tìm kiếm',
  serialNumber: 'STT',
  organizationUnit: 'Đơn vị',
  lookupInformation: 'Tra cứu thông tin',
  notReady: 'Chưa sẵn sàng',
  notReadyMessage: 'Nhấn sẵn sàng để bắt đầu nhận cuộc gọi của khách hàng.',
  ready: 'Bấm để sẵn sàng',
  readyV2: 'Chuyển sẵn sàng',
  isReady: 'Đã sẵn sàng',
  isReadyMessage: 'Vui lòng chú ý! Khách hàng có thể gọi đến bất kì lúc nào.',
  pause: 'Chuyển trạng thái bận',
  busy: 'Chuyển sang trạng thái bận',
  busyV2: 'Chuyển bận',
  isPause: 'Đang tạm ngưng',
  CreatingTicket: 'Đang tạo phiếu',
  isCreatingTicket: 'Nhấn sẵn sàng để bắt đầu nhận cuộc gọi khác.',
  inComingCall: 'Đang gọi đến',
  customerWaiting: 'Khách hàng đang chờ hỗ trợ.',
  failedLogin: 'Kết nối phần mềm World Phone thất bại',
  isFailedLogin: 'Vui lòng bấm "Kết nối World Phone" để tiến hành kết nối lại World Phone.',
  login: 'Kết nối World Phone',
  isTalking: 'Đang đàm thoại',
  openWorldPhoneWarning:
    'Hệ thống phát hiện có thể phần mềm World Phone chưa bật. Vui lòng mở phần mềm World Phone và thực hiện kết nối lại.',
  noExtensionFound: 'Hệ thống phát hiện bạn chưa có mã số extension. Vui lòng liên hệ quản trị để được hỗ trợ.',
  selectDistrict: 'Chọn Quận/Huyện',
  selectWard: 'Chọn Phường/Xã',
  PE: 'PE',
  refresh: 'Làm mới',
  meterSerialNumber: 'Số điện kế',
  routeCode: 'Phiên lộ trình',
  meterPointCode: 'Mã trạm',
  maxLength13Success: 'Đã nhập đủ 13 ký tự.',
  maxLength13Warning: 'Quá 13 ký tự.',
  lowVoltagePowerSupply: 'Cấp điện hạ áp',
  mediumVoltagePowerSupply: 'Cấp điện trung áp',
  highVoltagePowerSupply: 'Cấp điện cao áp',
  createAnonymousTicket: 'Tạo phiếu không định danh',
  selectServiceType: 'Chọn loại dịch vụ',
  entered: 'Đã nhập',
  character: 'ký tự.',
  enterMore: 'Nhập thêm',
  pleaseSelectDistrict: 'Vui lòng chọn quận trước!',
  complete: 'Đã xử lý',
  customerCicNumber: 'Số CCCD',
  chatFrom: (channelName: string) => `Chat qua kênh ${channelName}`,
  callFrom: 'Cuộc gọi đến',
  contactInfo: 'Thông tin người liên hệ',
  personalInfo: 'Thông tin cá nhân',
  phoneNumber: 'Điện thoại',
  idNumber: 'Số CCCD',
  dateProvided: 'Ngày cấp',
  placeProvided: 'Nơi cấp',
  address: 'Địa chỉ',
  email: 'Email',
  socialAddressAccount: 'Tài khoản mạng xã hội',
  negative: 'Tiêu cực',
  neutral: 'Trung lập',
  positive: 'Tích cực',
  behaviorCharacteristics: 'Đặc điểm hành vi',
  proposeCommunicationSolution: 'Đề nghị phương án giao tiếp',
  customersCode: 'Mã KH quan tâm',
  inprogressTickets: 'Phiếu đang xử lý',
  completedTickets: 'Phiếu đã hoàn thành',
  contactHistories: 'Lịch sử liên hệ',
  deleteNoteConfirm: 'Bạn có chắc chắn muốn xóa ghi chú này không?',
  deleteNoteWarning: 'Hành động này không thể hoàn tác.',
  isOwner: 'Chính chủ',
  note: 'Ghi chú',
  editNote(customerName: string): string {
    return `Nhập nội dung ghi chú cho khách hàng ${customerName}`;
  },
  customerVip: 'Khách hàng VIP'
};
